// Shared formatting helpers.

export function fmtDate(iso?: string | null): string {
  if (!iso) return "–";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return "–";
  }
}

export function calcKwh(start?: number | null, stop?: number | null): string {
  if (start == null || stop == null) return "–";
  return ((stop - start) / 1000).toFixed(2);
}

// Color mapping for MUI Chip components used as status badges.
export function statusColor(
  status: string
): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" {
  switch (status) {
    // drivers
    case "active":
    case "Available":
      return "success";
    case "inactive":
    case "Unavailable":
      return "default";
    case "suspended":
    case "SuspendedEV":
    case "SuspendedEVSE":
      return "warning";
    // chargers
    case "Faulted":
      return "error";
    // transactions
    case "Charging":
      return "primary";
    case "Preparing":
    case "Finishing":
    case "Reserved":
      return "info";
    default:
      return "default";
  }
}
